import React from "react";
import { Stepper, Step, StepLabel, StepConnector, StepIconProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import HorizontalRuleRoundedIcon from '@mui/icons-material/HorizontalRuleRounded';

interface CustomStepperProps {
  handleStepFunction: (event: any) => void;
  activeStep: number;
}

// Custom styles for Step Icon
const CustomStepIcon = styled("div")<{ active?: boolean; completed?: boolean }>(
  ({ active, completed }) => ({
    width: 30,
    height: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: completed ? "#1860CC" : "#fff",
    color: completed ? "#fff" : "#9e9e9e",
    fontSize: 18,
    fontWeight: "bold",
    border: completed ? "none" : "3px solid #C4C4C4",
  })
);

// Custom Step Connector (for progress line)
const CustomConnector = styled(StepConnector)(() => ({
  "& .MuiStepConnector-line": {
    borderColor: "#C4C4C4", // Gray line
    borderTopWidth: 3,
    marginTop: "2px",
  },
  // "&.Mui-active .MuiStepConnector-line": {
  //   background: "linear-gradient(to right, #1860CC 50%, #C4C4C4 50%)",
  //   borderColor: "#1860CC", // Blue line for active step
  //   marginTop: "2px",
  // },
  "&.Mui-completed .MuiStepConnector-line": {
    background: "linear-gradient(to right, #1860CC 50%, #C4C4C4 50%)",
    borderColor: "#1860CC", // Blue line for active step
    marginTop: "2px",
  },
}));

const StepIconComponent: React.FC<StepIconProps> = ({ active, completed }) => {
  return (
    <CustomStepIcon active={active} completed={completed} sx={{ width: "21px", height: "21px", mt: 0.7 }}>
      {completed ? <DoneOutlinedIcon fontSize="small" sx={{ width: "18px", height: "14px", fill: "#fff" }} /> 
      : <HorizontalRuleRoundedIcon fontSize="small" sx={{ width: "18px", height: "14px", fill: "#C4C4C4" }} />}
    </CustomStepIcon>
  );
};

// Steps
const steps: string[] = ["DASHBOARD", "SUMMARY", "DETAIL"];

const CustomStepper: React.FC<CustomStepperProps> = ({ handleStepFunction, activeStep }) => {
  return (
    <Stepper activeStep={activeStep} alternativeLabel connector={<CustomConnector />}>
      {steps.map((label, index) => {
        const isDisabled = index > activeStep && index !== 2; // Forward selection disabled

        return (
          <Step key={label} completed={index < activeStep}>
            <StepLabel
              onClick={() => (index < activeStep  && index !== 2) && handleStepFunction(index)} // Allow backward selection only
              StepIconComponent={StepIconComponent}
              sx={{
                cursor: index < activeStep && index !== 2 ? "pointer" : "",
                pointerEvents: index < activeStep ? "auto" : "none", // Prevent clicking future steps
                "& .MuiStepLabel-label": {
                  fontSize: 12,
                  fontWeight: "bold",
                  color: index <= activeStep ? "#1860CC" : "#C4C4C4",
                  opacity: isDisabled ? 0.5 : 1, // Reduce opacity for disabled steps
                },
                "& .Mui-completed": {
                  color: "#1860CC !important",
                  fontWeight: "bold",
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};


export default CustomStepper;
